import { useCallback, useEffect, useState } from "react";
import { academyRequest } from "./academyApi";

export type InstructorReviewAnalytics = {
  metricKey: "assessment.instructor_finalized_evaluation_count";
  definitionVersion: number;
  sourceDomain: "D11";
  availability: "available" | "stale" | "not_projected";
  values: { finalized?: number };
  suppressedCells: number;
  minimumCellCount: number;
  freshnessSeconds: number;
  calculatedAt: string | null;
  expiresAt: string | null;
  instructorUserId: string;
  individualReviewsAvailable: false;
  turnaroundAvailable: false;
  feedbackQualityAvailable: false;
  outcomesAvailable: false;
  performanceInferenceAvailable: false;
  transactionalAuthority: false;
  exportAvailable: false;
};

export function useInstructorReviewAnalytics(enabled: boolean) {
  const [data, setData] = useState<InstructorReviewAnalytics>();
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState("");
  const refresh = useCallback(async () => {
    if (!enabled) return;
    setLoading(true);
    setError("");
    try {
      setData(await academyRequest<InstructorReviewAnalytics>("instructor/dashboard/analytics/reviews"));
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "Instructor review analytics are unavailable.");
    } finally {
      setLoading(false);
    }
  }, [enabled]);
  useEffect(() => {
    if (enabled) void refresh();
    else {
      setData(undefined);
      setError("");
      setLoading(false);
    }
  }, [enabled, refresh]);
  return { data, loading, error, refresh };
}
